import type { Tiktoken } from "js-tiktoken"

let cachedEncoder: Tiktoken | null = null
let encoderPromise: Promise<Tiktoken> | null = null

const getEncoder = async (): Promise<Tiktoken> => {
  if (cachedEncoder) {
    return cachedEncoder
  }

  if (!encoderPromise) {
    encoderPromise = import("js-tiktoken").then(({ encodingForModel }) => {
      cachedEncoder = encodingForModel("gpt-4o")
      return cachedEncoder
    })
  }

  return encoderPromise
}

export const countTokens = async (text: string): Promise<number> => {
  try {
    const encoder = await getEncoder()
    const tokens = encoder.encode(text)
    return tokens.length
  } catch (error) {
    console.error("Error counting tokens:", error)
    return 0
  }
}

export const getTokens = async (text: string): Promise<string[]> => {
  try {
    const encoder = await getEncoder()
    const tokens = encoder.encode(text)
    const decoded = tokens.map((token) => encoder.decode([token]))
    return decoded
  } catch (error) {
    console.error("Error getting tokens:", error)
    return []
  }
}
